import { useEffect } from "react";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Process from "@/sections/Process";
import Upload from "@/sections/Upload";
import Gallery from "@/sections/Gallery";
import Consultation from "@/sections/Consultation";
import Footer from "@/sections/Footer";
import useSectionViewTracker from "@/hooks/useSectionViewTracker";
import { initAnalytics, initScrollTracker } from "@/lib/analytics";

export default function Home() {
  useSectionViewTracker();
  useEffect(() => {
    initAnalytics();
    const cleanup = initScrollTracker();
    return cleanup;
  }, []);
  return (
    <main className="bg-[#FFFFFF] text-slate-900 min-h-screen overflow-x-hidden" data-testid="home-page">
      <Navbar />
      <Hero />
      <Process />
      <Upload />
      <Gallery />
      <Consultation />
      <Footer />
    </main>
  );
}
